// Imports
import React from 'react';
import * as Sentry from '@sentry/browser';
import Heading from '../../../../../shareables/foundation/admin-ui/components/content/heading';
import Box from '../../../../../shareables/foundation/admin-ui/components/content/box';


// Component class
//  -> There are no Hooks for error boundary functions yet (https://reactjs.org/docs/error-boundaries.html)
class ContentErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean }> {
	constructor(props: { children: React.ReactNode }) {
		super(props);
		this.state = { hasError: false };
	}
	
	static getDerivedStateFromError() {
		return { hasError: true };
	}
	
	componentDidCatch(error: Error) {
		// Report to Sentry
		Sentry.captureException(error);
	}
	
	render() {
		if (this.state.hasError) {
			return (
				<React.Fragment>
					<Heading size={1}>Something went wrong</Heading>
					
					<Box>An unexpected issue occurred, and our engineering team has been notified.</Box>
				</React.Fragment>
			);
		}
		
		return this.props.children;
	}
}


// Export
export default ContentErrorBoundary;
